import React from 'react';
import { Box, Modal } from '@mui/material';
import MenuContent from '@components/common/MenuContent';
import SocialMediaIcons from '@components/common/SocialMediaIcons';
import ModalHeader from './ModalHeader';

interface MenuModalProps {
  open: boolean;
  handleClose: () => void;
}

export default function MenuModal({ open, handleClose }: MenuModalProps): React.JSX.Element {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      BackdropProps={{ style: { backgroundColor: '#191919' } }}
      sx={{ zIndex: 1302 }}
    >
      <Box className="w-full h-full overflow-y-auto">
        <ModalHeader handleClose={handleClose} />
        <Box className="items-center justify-center">
          <Box className="max-w-5xl mx-auto my-auto pl-20 mt-36">
            <MenuContent color="white" />
          </Box>
        </Box>
        <Box className="absolute p-8 right-0 bottom-0">
          <SocialMediaIcons color="white" />
        </Box>
      </Box>
    </Modal>
  );
}
